import { RuleOptions } from './types';

const SIDEBAR_WIDTH = '224px';

export default ({ theme, sidebar }: RuleOptions) => `
/*==================  Layout  ==================*/
:host {
  display: block;
  width: 100%;
  min-height: 320px;
  color: var(--md-default-fg-color);
  background: var(--md-default-bg-color);
}
html,
body,
.md-container,
.md-main,
.md-main__inner,
.md-content,
.md-content__inner {
  display: block;
  visibility: visible;
  opacity: 1;
}
html,
body {
  width: 100%;
  min-height: 100%;
  margin: 0;
}
.md-main {
  min-height: 320px;
}
/* mkdocs material v9 compat */
.md-nav__title {
  color: var(--md-default-fg-color);
}
.md-grid {
  max-width: 100%;
  margin: 0;
}
.md-nav {
  font-size: calc(var(--md-typeset-font-size) * 0.9);
}
nav.md-nav.md-nav--secondary {
  display: none;
}
.md-nav__link {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.md-nav__icon {
  height: 20px !important;
  width: 20px !important;
  margin-left:${theme.spacing(1)}px;
}
.md-nav__icon svg {
  margin: 0;
  width: 20px !important;
  height: 20px !important;
}
.md-nav__icon:after {
  width: 20px !important;
  height: 20px !important;
}
.md-nav__item--active > .md-nav__link, a.md-nav__link--active {
  text-decoration: underline;
  color: var(--md-typeset-a-color);
}
.md-main__inner {
  margin-top: 0;
}
.md-sidebar {
  bottom: 75px;
  position: fixed;
  width: 16rem;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-color: rgb(193, 193, 193) #eee;
  scrollbar-width: thin;
}
.md-sidebar .md-sidebar__scrollwrap {
  width: calc(12.1rem);
}
.md-sidebar--secondary {
  right: ${theme.spacing(3)}px;
}
.md-typeset table:not([class]) th,
.md-typeset table:not([class]) td {
  padding: 0.1rem 2rem 0.1rem 0.1rem;
}
.md-sidebar::-webkit-scrollbar {
  width: 5px;
}
.md-sidebar::-webkit-scrollbar-button {
  width: 5px;
  height: 5px;
}
.md-sidebar::-webkit-scrollbar-track {
  background: #eee;
  border: 1 px solid rgb(250, 250, 250);
  box-shadow: 0px 0px 3px #dfdfdf inset;
  border-radius: 3px;
}
.md-sidebar::-webkit-scrollbar-thumb {
  width: 5px;
  background: rgb(193, 193, 193);
  border: transparent;
  border-radius: 3px;
}
.md-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgb(125, 125, 125);
}
.md-content {
  max-width: calc(100% - 16rem - 6rem);
  margin-left: 16rem;
  margin-bottom: 50px;
}
.md-footer {
  position: fixed;
  bottom: 0px;
  pointer-events: none;
}
.md-footer-nav__link, .md-footer__link {
  pointer-events: all;
}
.md-footer__title {
  background-color: unset;
}
.md-footer-nav__link {
  width: 16rem;
}
.md-dialog {
  background-color: unset;
}
@media screen and (min-width: 76.25em) {
  .md-sidebar {
    height: auto;
  }
}
@media screen and (max-width: 76.1875em) {
  .md-nav {
    transition: none !important;
    background-color: var(--md-default-bg-color)
  }
  .md-nav--primary .md-nav__title {
    cursor: auto;
    color: var(--md-default-fg-color);
    font-weight: 700;
    white-space: normal;
    line-height: 1rem;
    height: auto;
    display: flex;
    flex-flow: column;
    row-gap: 1.6rem;
    padding: 1.2rem .8rem .8rem;
    background-color: var(--md-default-bg-color);
  }
  .md-nav--primary .md-nav__title~.md-nav__list {
    box-shadow: none;
  }
  .md-nav--primary .md-nav__title ~ .md-nav__list > :first-child {
    border-top: none;
  }
  .md-nav--primary .md-nav__title .md-nav__button {
    display: none;
  }
  .md-nav--primary .md-nav__title .md-nav__icon {
    color: var(--md-default-fg-color);
    position: static;
    height: auto;
    margin: 0 0 0 -0.2rem;
  }
  .md-nav--primary > .md-nav__title [for="none"] {
    padding-top: 0;
  }
  .md-nav--primary .md-nav__item {
    border-top: none;
  }
  .md-nav--primary :is(.md-nav__title,.md-nav__item) {
    font-size : var(--md-typeset-font-size);
  }
  .md-nav .md-source {
    display: none;
  }
  .md-sidebar {
    height: 100%;
  }
  .md-sidebar--primary {
    width: 12.1rem !important;
    z-index: 200;
    left: ${
      sidebar.isPinned
        ? `calc(-12.1rem + ${SIDEBAR_WIDTH})`
        : 'calc(-12.1rem + 72px)'
    } !important;
  }
  .md-sidebar--secondary:not([hidden]) {
    display: none;
  }
  .md-content {
    max-width: 100%;
    margin-left: 0;
  }
  .md-header__button {
    margin: 0.4rem 0;
    margin-left: 0.4rem;
    padding: 0;
  }
  .md-overlay {
    left: 0;
  }
  .md-footer {
    position: static;
    padding-left: 0;
  }
  .md-footer-nav__link {
    /* footer links begin to overlap at small sizes without setting width */
    width: 50%;
  }
}
@media screen and (max-width: 600px) {
  .md-sidebar--primary {
    left: -12.1rem !important;
    width: 12.1rem;
  }
}
`;

// .md-content {
//    max-width: calc(100% - 16rem * 2);
// }
